module.exports = __webpack_public_path__ + "img/1-1.02670bc4.png";